import { LiteralTypeEnum, OperatorEnum, VariableTypeEnum } from './types'

// The literal type is determined at runtime, based on the variable type and the comparison operator
// When operator is 'one_of' or 'not_one_of', we use integer_array type for the literal
export const getLiteralType = (
  variableType?: VariableTypeEnum,
  operator?: OperatorEnum
): LiteralTypeEnum => {
  // If operator is 'one_of' or 'not_one_of', return integer_array regardless of variable type
  if (operator === 'one_of' || operator === 'not_one_of') {
    return 'integer_array'
  }

  switch (variableType) {
    case 'integer':
      return 'integer'
    case 'boolean':
      return 'boolean'
    case 'float':
      return 'float'
    case 'string':
    default:
      return 'string'
  }
}
